// Blob hashes are already SHA-256s, so concatenating sorted (path, blobHash)
// pairs is sufficient — equality means identical file content. We digest only
// when the concatenation would overflow Postgres' ~2700-byte B-tree index tuple
// limit, keeping the raw form otherwise so under-limit rows already stored stay
// matchable without a backfill (a hex digest can't collide — it has no '/' or '=').
const MAX_RAW_CONTENT_HASH_BYTES = 2048;

export async function computeContentHash(
  parts: { path: string; blobHash: string }[]
): Promise<string> {
  const canonical = [...parts]
    .sort((a, b) => a.path.localeCompare(b.path))
    .map((p) => `${p.path}=${p.blobHash}`)
    .join("\n");
  const bytes = new TextEncoder().encode(canonical);
  if (bytes.length <= MAX_RAW_CONTENT_HASH_BYTES) return canonical;
  const buf = await crypto.subtle.digest("SHA-256", bytes);
  return [...new Uint8Array(buf)]
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
